export default {
  route: {
    news: '消息',
    workbench: '工作台',
    statistics: '统计',
    user: '我的',
    orderList: '订单列表',
    orderDetail: '订单详情',
    dispatch: '调度',
    loading: '装货',
    changeFactory: '转仓',
    orderMsg: '订单信息',
    dispatchDetail: '调度信息',
    dispatchDetailEdit: '调度信息编辑',
    loadingDetail: '装货信息',
    inspectionDetail: '验货信息'
  },
  btn: {
    edit: '编辑',
    save: '保存',
    sure: '确认',
    confirm: '确定',
    cancel: '取消',
    delete: '删除'
  },
  treatment: {
    sales: '销售系统',
    salesTitle: '销售工作台',
    recycle: '回收系统',
    recycleTitle: '回收工作台',
    waitingScheduling: '待调度',
    waitingShipping: '待装货',
    waitingInspection: '待验货',
    waitingWarehousing: '待入库',
    warehoused: '已入库',
    abnormalPending: '异常待处理',
    all: '全部',
    workData: '工作数据',
    plan: '回收行程安排',
    quantity: '回收总重量(kg)',
    amount: '回收总金额(元)',
    orderNumber: '订单数',
    showAll: '展开全部'
  }
}



// WEBPACK FOOTER //
// ./src/lang/zh.js